const FormularioInformacionCaso = props => {
  return (
    <div>
      <h2>{i18next.t("informacionCaso")}</h2>
      <form className="form-horizontal">
        <div className="form-group">
          <label htmlFor="name" className="col-sm-3 control-label">
            {i18next.t("numRadicado")}
          </label>
          <div className="col-sm-9">
            <input type="text" disabled className="form-control" value={props.radicado} />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="name" className="col-sm-3 control-label">
            {i18next.t("asesor")}
          </label>
          <div className="col-sm-9">
            <input type="text" disabled className="form-control" value={props.form.asesorName} />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="name" className="col-sm-3 control-label">
            {i18next.t("fechaAsegurabilidad")}
          </label>
          <div className="col-sm-9">
            <input type="text" disabled className="form-control" value={props.form.viabilitySentDate} />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="name" className="col-sm-3 control-label">
            {i18next.t("fechaVencimiento")}
          </label>
          <div className="col-sm-9">
            <input type="text" disabled className="form-control" value={props.form.expirationDate} />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="name" className="col-sm-3 control-label">
            {i18next.t("numFactura")}
          </label>
          <div className="col-sm-9">
            <input type="text" disabled className="form-control" value={props.form.billNumber} />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="name" className="col-sm-3 control-label">
            {i18next.t("estado")}
          </label>
          <div className="col-sm-9">
            <input type="text" disabled className="form-control" value={props.form.processState} />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="name" className="col-sm-3 control-label">
            {i18next.t("numIntegrantesContrato")}
          </label>
          <div className="col-sm-9">
            <input type="text" disabled className="form-control" value={props.form.participants} />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="name" className="col-sm-3 control-label">
            {i18next.t("afiliadosCondiciones")}
          </label>
          <div className="col-sm-9">
            <input type="text" disabled className="form-control" value={props.form.subscribed.viabilitySubscribed.length} />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="name" className="col-sm-3 control-label">
            {i18next.t("afiliadosRiesgosuDiagnosticos")}
          </label>
          <div className="col-sm-9">
            <input type="text" disabled className="form-control" value={props.form.subscribed.riskySubscribed.length} />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="name" className="col-sm-3 control-label">
            {i18next.t("declaracionAsegurabilidad")}
          </label>
          <div className="col-sm-9">
            <a className="c-pointer document-link" href={`${_spPageContextInfo.webAbsoluteUrl}/${props.form.viabilityDocument.documentUrl}`} target="_blank" >
              {props.form.viabilityDocument.documentName}
            </a>
          </div>
        </div>
      </form>
      <h2>{i18next.t("infoContratante")}</h2>
      <form className="form-horizontal">
        <div className="form-group">
          <label htmlFor="name" className="col-sm-3 control-label">
            {i18next.t("tipoDocumento")}
          </label>
          <div className="col-sm-9">
            <input type="text" disabled className="form-control" value={props.form.contractor.identification.type} />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="name" className="col-sm-3 control-label">
            {i18next.t("documento")}
          </label>
          <div className="col-sm-9">
            <input type="text" disabled className="form-control" value={props.form.contractor.identification.number} />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="name" className="col-sm-3 control-label">
            {i18next.t("nombre")}
          </label>
          <div className="col-sm-9">
            <input type="text" disabled className="form-control" value={props.form.contractor.name.value} />
          </div>
        </div>
      </form>
      {!props.isAfilliateViability && <h2>{i18next.t("infoAfiliados")}</h2>}
      {!props.isAfilliateViability && (<form className="form-horizontal">
        <div className="form-group">
          <label className="col-sm-3 control-label">
            {i18next.t("afiliadosCondiciones")}
          </label>
          <div className="col-sm-9 afilliate-group">
            {props.form.subscribed.viabilitySubscribed.length > 0 ? props.form.subscribed.viabilitySubscribed.map(afiliado => {
              return (
                <a className="afiliado-name" href={`${_spPageContextInfo.webAbsoluteUrl}${props.configurations["UrlViabilidadInformacionAfiliado"]}?tipoIdentificacion=${afiliado.identification.typeId}&numeroIdentificacion=${afiliado.identification.number}&esDefinicionViabilidad=${false}&radicado=${props.radicado}`}>
                  <label>{afiliado.name.value}</label>
                </a>
              );
            }) : <label>Sin Afiliados</label>}
          </div>
        </div>
        <div className="form-group">
          <label className="col-sm-3 control-label">
            {i18next.t("afiliadosRiesgosuDiagnosticos")}
          </label>
          <div className="col-sm-9 afilliate-group">
            {props.form.subscribed.riskySubscribed.length > 0 ? props.form.subscribed.riskySubscribed.map(afiliado => {
              return (
                <a className="afiliado-name" href={`${_spPageContextInfo.webAbsoluteUrl}/${props.configurations["UrlViabilidadInformacionAfiliado"]}?tipoIdentificacion=${afiliado.identification.typeId}&numeroIdentificacion=${afiliado.identification.number}&esDefinicionViabilidad=${false}&radicado=${props.radicado}`} >
                  <label>{afiliado.name.value}}</label>
                </a>
              );
            }) : <label>Sin Afiliados</label>}
          </div>
        </div>
      </form>)}
    </div>
  );
};


const Popover = ReactBootstrap.Popover;
const MenuItem = ReactBootstrap.MenuItem;
const DropdownButton = ReactBootstrap.DropdownButton;
const Button = ReactBootstrap.Button;
const OverlayTrigger = ReactBootstrap.OverlayTrigger;


export default FormularioInformacionCaso; 


// WEBPACK FOOTER //
// ./cicloVentaAfiliacion/informacionDelCasoAsegurabilidad/src/components/formularioInformacionCaso.js